module.exports = __webpack_public_path__ + "static/media/ontvangen.03d57ea2.svg";